/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, December 6th 2021, 2:44:22 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { IconText } from "ui-widgets";
import { Briefcase } from "react-feather";
import { COLORSCHEME } from "theme/styles";
import { DepartmentForm } from "organizations/components/DepartmentForm";
import { NestedOne2ManyPopupFormInput, Typography, ConcreteAPIRelatedFormPopupInputProps } from "ui-widgets";
import { Organization, Department } from "lib/schemas";

export const DepartmentNestedPopUpField = ({
  ...departmentFormInputProps
}: ConcreteAPIRelatedFormPopupInputProps<Organization, Department> & {
  newDepartmentDefault?: Department;
  showAddWorkers?: boolean;
}) => {
  return (
    <NestedOne2ManyPopupFormInput<Organization, Department>
      renderRelatedObjectForm={({ currentEditItem, handleClose, onChangeRelatedItem }) => (
        <DepartmentForm
          defaultItemValue={currentEditItem ?? departmentFormInputProps.newDepartmentDefault}
          onFormCancel={handleClose}
          handleValidForm={onChangeRelatedItem}
          showAddWorkers={departmentFormInputProps.showAddWorkers}
        />
      )}
      popUpTitle={
        <Typography>
          <IconText
            icon={<Briefcase color={COLORSCHEME.secondaryVariant} />}
            textComponent={<Typography variant="h5">Organization Department</Typography>}
          />
        </Typography>
      }
      itemIdProperty="id"
      getOptionLabel={(option) => option.name}
      schema_field_key={departmentFormInputProps.schema_field_key}
      label={departmentFormInputProps.label}
    />
  );
};
